import React, { useEffect, useState } from 'react';
import './animations.css';
import schoolgate from "../Assets/schoolgate.jpg";

const Secone = () => {

    const [showContent, setShowContent] = useState(false);

    useEffect(() => {
        setShowContent(true);
    }, []);

    return (
        <div className="w-full bg-[#F6F5F1]">
            <div className="relative w-full px-0 md:px-0 lg:px-0 pt-10 md:pt-16">
                <div
                    className="relative w-full min-h-[520px] md:min-h-[560px] bg-cover bg-center rounded-sm overflow-hidden"
                    style={{ backgroundImage: `url(${schoolgate})` }}
                >
                    <div className="absolute inset-0 bg-[#12213D]/80" />

                    <div className="relative z-10 max-w-xl px-6 py-14 md:px-12 md:py-20">

                        <div
                            className={`inline-flex items-center gap-2 w-fit px-3 py-1.5 mb-8 border border-[#B8862E]/50 rounded-full ${showContent ? 'p-slide-in' : 'hidden-initially'}`}
                        >
                            <span className="w-1.5 h-1.5 rounded-full bg-[#B8862E]" />
                            <span className="text-[#E7E1D3] text-sm" style={{ fontFamily: "'Inter', sans-serif" }}>
                                Admissions open for 2026/27 session
                            </span>
                        </div>

                        <h1
                            className={`text-[#F6F5F1] text-4xl md:text-5xl lg:text-[3.25rem] leading-[1.1] ${showContent ? 'h2-slide-in' : 'hidden-initially'}`}
                            style={{ fontFamily: "'Fraunces', serif", fontWeight: 500 }}
                        >
                            Educated by hand,
                            <br />
                            guided by mind.
                        </h1>

                        <p
                            className={`mt-6 max-w-md text-[#C7CCDA] text-base md:text-lg leading-relaxed ${showContent ? 'p-slide-in' : 'hidden-initially'}`}
                            style={{ fontFamily: "'Inter', sans-serif" }}
                        >
                            A community built around rigorous academics, hands-on craft, and mentors who know your name. Explore the programs that shape how our students think and build.
                        </p>

                        <div className="flex flex-wrap items-center gap-4 mt-10">
                            <button
                                className="bg-[#B8862E] hover:bg-[#a3781f] text-[#12213D] px-6 py-3 rounded-sm text-sm font-medium transition-colors"
                                style={{ fontFamily: "'Inter', sans-serif" }}
                            >
                                Apply now
                            </button>
                            <button
                                className="border border-[#C7CCDA]/40 hover:border-[#C7CCDA] text-[#F6F5F1] px-6 py-3 rounded-sm text-sm font-medium transition-colors"
                                style={{ fontFamily: "'Inter', sans-serif" }}
                            >
                                Explore programs
                            </button>
                        </div>
                    </div>
                </div>

                <div className="relative md:absolute md:left-16 md:right-16 md:-bottom-10 mt-6 md:mt-0">
                    <div className="bg-white border border-[#12213D]/10 rounded-sm shadow-[0_8px_30px_rgba(18,33,61,0.08)] grid grid-cols-2 md:grid-cols-4 divide-y md:divide-y-0 md:divide-x divide-[#12213D]/10">
                        {[
                            { value: "1965", label: "Founded" },
                            { value: "12,400", label: "Students enrolled" },
                            { value: "85", label: "Degree programs" },
                            { value: "94%", label: "Graduate employment" },
                        ].map((stat) => (
                            <div key={stat.label} className="px-6 py-5">
                                <div
                                    className="text-[#12213D] text-2xl"
                                    style={{ fontFamily: "'Fraunces', serif", fontWeight: 500 }}
                                >
                                    {stat.value}
                                </div>
                                <div
                                    className="text-[#5B6472] text-sm mt-1"
                                    style={{ fontFamily: "'Inter', sans-serif" }}
                                >
                                    {stat.label}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className="hidden md:block h-24" />
        </div>
    )
}

export default Secone;